<template>
    <div class="row justify-content-center">
        <div class="col-lg-6 card-wrapper metadata">
            <card>
                <!-- Card header -->

                <div class="card-header">
                    <h2 class="card-title mb-0">
                        Design decision
                    </h2>
                </div>

                <div class="card-body">
                    <!-- Card body -->
                    
                </div>
            </card>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'

export default {
    name: 'note',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip
    },
    methods: {
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
        }),
    },
};
</script>